import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
	async getAllCCMImagingByPatientId (patientId) {
		try {
			const response = await _axios.get(
				`/ccmimaging/getbypatientid/${patientId}`,
			);
			if (response.data.resFlag) {
				return response.data;
			} else if (response.data.data === null) {
				return [];
			}
			throw new CCMError('Error getting all CCM Imaging by patient ID');
		} catch (error) {
			throw new CCMError(`Failed to fetch imaging records: ${error.message}`);
		}
	},

	async getSingleCCMImagingByPatientId (patientId, imagingId) {
		try {
			const response = await _axios.get(
				`/ccmimaging/${patientId}/${imagingId}`,
			);
			if (response.data.resFlag) {
				return response.data;
			}
			throw new CCMError(
				'Error getting single CCM Imaging by patient and imaging ID',
			);
		} catch (error) {
			throw new CCMError(
				`Failed to fetch single imaging record: ${error.message}`,
			);
		}
	},

	async getCCMImaging (id) {
		try {
			const response = await _axios.get(`/ccmimaging/${id}`, {
				responseType: 'blob',
			});
			if (response.data) {
				return response.data;
			}
			throw new CCMError('Error getting CCM Imaging');
		} catch (error) {
			throw new CCMError(
				`Failed to fetch imaging record by ID: ${error.message}`,
			);
		}
	},

	async addCCMImaging (body) {
		try {
			const response = await _axios.post('/ccmimaging', body);
			if (response.data.resFlag) {
				return response.data;
			}
			throw new CCMError('Error adding CCM Imaging');
		} catch (error) {
			throw new CCMError(`Failed to add imaging record: ${error.message}`);
		}
	},

	async deleteCCMImaging (id) {
		try {
			const response = await _axios.delete(`/ccmimaging/${id}`);
			if (response.data.resFlag) {
				return response.data;
			}
			throw new CCMError('Error deleting CCM Imaging');
		} catch (error) {
			throw new CCMError(`Failed to delete imaging record: ${error.message}`);
		}
	},
};
